import {useEffect} from "react";
import cn from "classnames";
import "./style.css";
import {isSmallScreen} from "../../helpers/screens";

/*
 * Read the blog post here:
 * https://letsbuildui.dev/articles/building-a-drawer-component-with-react-portals
 */
const Drawer = ({
  isOpen,
  children,
  className="",
  onClose,
  position = "right",
  size="50",
  minsize="50",
  showBackdrop = true
}: any) => {
  // Allow Escape key to dismiss the drawer
  const drawer_mobile_cls = isSmallScreen() ? "drawer_mobile" :"";

  useEffect(() => {
    const onKeyPress = (e: any) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    if (isOpen) {
      window.addEventListener("keyup", onKeyPress);
    }

    return () => {
      window.removeEventListener("keyup", onKeyPress);
    };
  }, [isOpen, onClose]);
  if(!isOpen) return null

  return (
    <div
      aria-hidden={isOpen ? "false" : "true"}
      className={cn("drawer-container !fixed z-[9999] w-full h-full top-0", {
        open: isOpen,
        in:true,
        className
      })}
      onClick={onClose}
    >
      <div
        className={cn(`drawer bg-white dark:bg-[#111928] z-[9999] ${drawer_mobile_cls}`,position)}
        role="dialog"
        style={{maxWidth:`${size}%`,minWidth:`${minsize}%`}}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>

      {showBackdrop && (
        <div className="backdrop" />
      )}
    </div>
  );
};

export default Drawer;
